// ─────────────────────────────────────────────────────────────────
// Glass-i — Journal Voucher grid columns (Stage 6B.4).
// ─────────────────────────────────────────────────────────────────

import { Tag } from 'antd';
import {
  formatINR
} from '../../../../components/common/erp-grid';
import { STATUS_COLOR, STATUS_LABEL, VOUCHER_TYPE_LABEL } from './voucherConstants';

function fmtDate(v) {
  return v ? String(v).slice(0, 10) : <span className="erp-grid__muted">—</span>;
}

function fmtTs(v) {
  if (!v) return <span className="erp-grid__muted">—</span>;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return v;
  return <span>{d.toISOString().slice(0, 10)} {d.toISOString().slice(11, 16)}</span>;
}

export function buildVoucherColumns({ currentPage, pageSize } = {}) {
  return [
    { title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return <span className="erp-grid__muted">{(cp - 1) * ps + idx + 1}</span>;
      } },
    { title: 'Voucher No', dataIndex: 'voucherNo', key: 'voucherNo',
      sortField: 'voucher_no', sorter: true,
      width: 160, fixed: 'left',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span> },
    { title: 'Date', dataIndex: 'voucherDate', key: 'voucherDate',
      sortField: 'voucher_date', sorter: true,
      width: 110, dataType: 'date', render: fmtDate },
    { title: 'Type', dataIndex: 'voucherType', key: 'voucherType',
      sortField: 'voucher_type', width: 110,
      dataType: 'enum',
      render: (v) => <Tag color="blue" className="erp-grid__tag">{VOUCHER_TYPE_LABEL[v] || v}</Tag> },
    { title: 'Narration', dataIndex: 'narration', key: 'narration',
      width: 320, ellipsis: true,
      render: (v) => v || <span className="erp-grid__muted">—</span> },
    { title: 'Total Debit (₹)', dataIndex: 'totalDebit', key: 'totalDebit',
      sortField: 'total_debit', sorter: true,
      width: 140, align: 'right',
      render: (v) => {
        const n = Number(v) || 0;
        return n === 0 ? <span className="erp-grid__muted">—</span> : formatINR(n);
      } },
    { title: 'Total Credit (₹)', dataIndex: 'totalCredit', key: 'totalCredit',
      sortField: 'total_credit', sorter: true,
      width: 140, align: 'right',
      render: (v) => {
        const n = Number(v) || 0;
        return n === 0 ? <span className="erp-grid__muted">—</span> : formatINR(n);
      } },
    { title: 'Status', dataIndex: 'status', key: 'status',
      sortField: 'status', sorter: true,
      width: 100, align: 'center',
      dataType: 'enum',
      groupable: true, groupField: 'status',
      filters: [
        { text: 'Draft',     value: 'draft' },
        { text: 'Posted',    value: 'posted' },
        { text: 'Cancelled', value: 'cancelled' }
      ],
      filterField: 'status',
      render: (v) => (
        <Tag color={STATUS_COLOR[v] || 'default'} className="erp-grid__tag" style={{ marginInlineEnd: 0 }}>
          {(STATUS_LABEL[v] || v || '').toUpperCase()}
        </Tag>
      ) },
    { title: 'Posted At', dataIndex: 'postedAt', key: 'postedAt',
      sortField: 'posted_at', sorter: true,
      width: 160, dataType: 'date', render: fmtTs }
  ];
}
